export const showReviewLocation = review => {
	const locationPieces = [];

	if (review.organization_city) {
		locationPieces.push(review.organization_city);
	}

	if (review.organization_province) {
		locationPieces.push(review.organization_province);
	}

	return locationPieces.join(", ");
};



// WEBPACK FOOTER //
// ./src/utils/reviews/reviewLocation.js